/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  ComponentType,
  useState
} from 'react'
import {
  Form,
  Radio
} from 'semantic-ui-react'
// Local
import { CONDITION } from '../../../constant'
import { formatIcd10Code } from '../../common/formatUtils'
import If from '../../common/if'
import {
  EncounterConditionCdiTagsRow,
  EncounterConditionDisplay
} from '../../authenticated/types'

const SafeForm = Form as unknown as ComponentType<any>

/**
 * Provides a component that allows a CDI user to edit CDI potential condition
 * tag properties. For example: mark a condition as Net New, Known Potential or Neither.
 *
 * @param condition Condition entity
 * @param onConditionAction Callback for condition action
 *        Arguments action, condition
 */

type Props = {
  condition: EncounterConditionDisplay
  onConditionAction: (
    action: keyof typeof CONDITION.ACTION,
    condition: EncounterConditionDisplay[] | EncounterConditionDisplay | string
  ) => void
}

function CdiPotentialConditionTagsEditor(
  props: Props
): JSX.Element {
  const {
    condition,
    onConditionAction
  } = props

  const [
    cdiTagsState,
    setCdiTagsState
  ] = useState<Partial<EncounterConditionCdiTagsRow>>(
    condition.cdiTags
      ? condition.cdiTags
      : {
        encounterConditionId: condition.id,
        netNewStatusCode: null,
        knownPotentialStatusCode: null,
        expectedDiagnosis: null
      }
  )

  // const getNetNewStatusCode = (value: string) => {
  //   if (value === 'NONE') return null
  //   if (value === 'CONDITION.NET_NEW') return CONDITION.NET_NEW
  //   if (value === 'CONDITION.KNOWN_POTENTIAL') return CONDITION.KNOWN_POTENTIAL
  //   return cdiTagsState.netNewStatusCode
  // }

  // const getKnownPotentialStatusCode = (value: string) => {
  //   if (value === 'NONE') return null
  //   if (value === 'CONDITION.NET_NEW') return null
  //   return cdiTagsState.knownPotentialStatusCode
  // }

  const onChange = (
    e: any,
    { value }: any
  ) => {
    const temporaryTagsState = {} as Partial<EncounterConditionCdiTagsRow>
    if (value === 'NONE') {
      temporaryTagsState.netNewStatusCode = null
      temporaryTagsState.knownPotentialStatusCode = null
    }
    if (value === CONDITION.NET_NEW) {
      temporaryTagsState.netNewStatusCode = CONDITION.NET_NEW
      temporaryTagsState.knownPotentialStatusCode = null
    }
    if (value === CONDITION.KNOWN_POTENTIAL) {
      temporaryTagsState.knownPotentialStatusCode = CONDITION.KNOWN_POTENTIAL
      temporaryTagsState.netNewStatusCode = null
    }
    temporaryTagsState.encounterConditionId = condition.id
    setCdiTagsState(temporaryTagsState)
    const revisedConditon = {
      ...condition,
      cdiTags: {
        ...condition.cdiTags,
        ...temporaryTagsState
      }
    } as EncounterConditionDisplay
    onConditionAction(
      CONDITION.ACTION.UPDATE_CDI_TAGS,
      revisedConditon
    )
  }

  const isNetNew = cdiTagsState && cdiTagsState.netNewStatusCode === CONDITION.NET_NEW
  const isKnownPotential = cdiTagsState && cdiTagsState.knownPotentialStatusCode === CONDITION.KNOWN_POTENTIAL
  const expectedDiagnosis = cdiTagsState && cdiTagsState.expectedDiagnosis
    ? cdiTagsState.expectedDiagnosis
    : null
  return (
    <SafeForm className="m-1-top">
      <Form.Group inline>
        <label>Mark Condition:</label>
        <Form.Field
          control={ Radio }
          label="Net New"
          name="netNewKnownPotential"
          value={ CONDITION.NET_NEW }
          checked={ isNetNew }
          onChange={ onChange } />
        <Form.Field
          control={ Radio }
          label="Known Potential"
          name="netNewKnownPotential"
          value={ CONDITION.KNOWN_POTENTIAL }
          checked={ isKnownPotential }
          onChange={ onChange } />
        <Form.Field
          control={ Radio }
          label="Neither"
          name="netNewKnownPotential"
          value="NONE"
          checked={ !(isNetNew || isKnownPotential) }
          onChange={ onChange } />
      </Form.Group>
      <If isTrue={ !!expectedDiagnosis }>
        <div className="m-1-top">
          Expected Diagnosis: <strong>{ formatIcd10Code(expectedDiagnosis) }</strong>
        </div>
      </If>
    </SafeForm>
  )
}

export default CdiPotentialConditionTagsEditor
